var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{staticClass:"line",attrs:{"fill":"currentColor","d":"M25.6 6.88A66.43 66.43 0 0 0 16 6.4a66.43 66.43 0 0 0-9.6.48C4.48 7.48 4 11.68 4 16s.48 8.52 2.4 9.12a66.43 66.43 0 0 0 9.6.48 66.43 66.43 0 0 0 9.6-.48c1.92-.6 2.4-4.8 2.4-9.12s-.48-8.52-2.4-9.12zm-12 14.52V10.6l7.2 5.4-7.2 5.4z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }